import React, { useState, useEffect, useContext, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { Tooltip, Breadcrumb, Button, BreadcrumbItem, Tile, Tag, Link, OverflowMenuItem, OverflowMenu, Form, Modal, InlineNotification, NotificationActionButton, TextInput } from 'carbon-components-react'
import Toast from '../../components/Notification/Toast'
import AuthContext from '../../context/AuthContext'
import ReactQuill from 'react-quill';
import parse from 'html-react-parser';
import 'react-quill/dist/quill.snow.css';
import SunEditor, { buttonList } from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS File

const { REACT_APP_DEV_API_URL, REACT_APP_PROD_API_URL, NODE_ENV } = process.env;
const API_URL =
    NODE_ENV === 'production' ? process.env.REACT_APP_PROD_API_URL : process.env.REACT_APP_DEV_API_URL;

const SITE_URL =
    NODE_ENV === 'production' ? process.env.REACT_APP_PROD_MEDIA_URL : process.env.REACT_APP_DEV_MEDIA_URL;

const AgreementShell = ({ match }) => {

    // Quill Modules & Formats
    const modules = {
        toolbar: [
            [{ header: '1' }, { header: '2' }, { font: [] }],
            [{ size: [] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'align': [] }],
            [
                { list: 'ordered' },
                { list: 'bullet' },
                { indent: '-1' },
                { indent: '+1' },
            ],
            [{ 'color': [] }, { 'background': [] }],
            ['link', 'image', 'video'],
            ['clean'],
        ],
        clipboard: {
            // toggle to add extra line breaks when pasting HTML:
            matchVisual: false
        },
    }

    const formats = [
        'header',
        'font',
        'size',
        'bold',
        'italic',
        'underline',
        'strike',
        'blockquote',
        'list',
        'align',
        'bullet',
        'indent',
        'link',
        'image',
        'video',
        'color', 'background'
    ]

    let { authTokens } = useContext(AuthContext)

    const [list, setList] = useState([]);
    const [editorContent, setEditorContent] = useState('')
    let toastProperties = null;

    //assigning location variable
    const location = useLocation();

    //destructuring pathname from location
    const { pathname } = location;

    //Javascript split method to get the name of the path in array
    const splitLocation = pathname.split("/");

    // Variables for modals and toasts
    const [error, setError] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [editContactID, setEditContactID] = useState(false);
    const [openEditAgreementModal, setOpenEditAgreementModal] = useState(false);
    const editAgreementForm = useRef();

    // Variables for noteSeaarch
    let [client, setClients] = useState(null)

    // Other Variables
    let profileId = match.params.id
    let [tabActive, setTabActive] = useState(true)
    let [page, setPage] = useState(null)
    let [contacts, setContacts] = useState([])
    let [clientAddress, setClientAddress] = useState(null)
    let [clientAddresses, setClientAddresses] = useState(null)
    let [clientPhoneNumbers, setClientPhoneNumbers] = useState(null)
    let [clientEmailAddresses, setClientEmailAddresses] = useState(null)
    let [clientMailingAddress, setClientMailingAddress] = useState(null)
    let [clientBillingAddress, setClientBillingAddress] = useState(null)
    let [clientSettings, setClientSettings] = useState(null)
    let [currencies, setCurrencies] = useState(null)
    let [currencyCode, setCurrencyCode] = useState(null)
    let [countries, setCountries] = useState(null)
    let [clientCountry, setClientCountry] = useState(null)
    let [savedState, setSavedState] = useState('No Changes Made')

    useEffect(() => {
        getAgreement()
        document.title = "Agreement Details | WillowBMS"
        setPage(splitLocation[2])
    }, [profileId, editContactID])

    useEffect(() => {
        setPage(splitLocation[2])
    })

    let getAgreement = async () => {
        let response = await fetch(`${API_URL}/agreements/${profileId}/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authTokens?.access
            }
        })
        let data = await response.json()
        setClients(data)
        setEditorContent(data.content)
    }

    let editAgreement = async () => {
        let response = await fetch(`${API_URL}/agreements/${profileId}/`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authTokens?.access
            },
            body: JSON.stringify({
                'content': editorContent,
                'name': client.name,
                'startdate': client.startdate
            })
        })

        if (response.status === 200) {
            showToast("success", "Success", "Agreement content has been saved.")
            setSavedState("All Changes Saved")
        } else {
            showToast("error", "Error", "Unable to save agreement content. Please try again.")
        }
    }

    let editAgreementInformation = async (values) => {
        values.preventDefault()
        let response = await fetch(`${API_URL}/agreements/${profileId}/`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authTokens?.access
            },
            body: JSON.stringify({
                'content': editorContent,
                'name': values.target.name.value,
                'startdate': client.startdate
            })
        })

        if (response.status === 200) {
            setOpenEditAgreementModal(false)
            getAgreement()
            showToast("success", "Success", "Agreement information has been saved.")
            setSavedState("All Changes Saved")
        } else {
            showToast("error", "Error", "Unable to save agreement information. Please try again.")
        }
    }

    const showToast = (type, title, description) => {
        const id = Math.floor((Math.random() * 100) + 1);
        const time = new Date().toLocaleString();

        switch (type) {
            case 'success':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'success',
                    time: time
                }
                break;
            case 'error':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'error',
                    time: time
                }
                break;
            case 'info':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'info',
                    time: time
                }
                break;
            case 'warning':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'warning',
                    time: time
                }
                break;
            default:
                setList([]);
        }
        setList([...list, toastProperties]);
    }

    const validateMessages = {
        required: 'Field is required',
        types: {
            email: 'Please enter a valid email',
            number: 'Not a valid number',
        },
    };

    return (
        <div className="bms-page">
            {client &&
                <>
                    <Toast toastList={list} />
                    <div className="mb-2">
                        <Breadcrumb>
                            <BreadcrumbItem href="/agreements">Agreements</BreadcrumbItem>
                            <BreadcrumbItem href={`/agreements/${client.id}`}>{client.name}</BreadcrumbItem>
                            <span>Details</span>
                        </Breadcrumb>
                    </div>
                    <div>
                        <div className="w-full summary-header">
                            <Tile><strong className="d-flex">#{client.id} - {client.name}</strong></Tile>
                            <Tile light={true} className="w-full d-flex" style={{ minHeight: 0 }}>
                                <div className="col-6">
                                    <strong className="lh-27 d-flex">Summary</strong>
                                </div>
                                <div className="col-6 d-flex">
                                    <div className="ml-auto">
                                        <OverflowMenu className="ml-auto">
                                            <OverflowMenuItem onClick={() => setOpenEditAgreementModal(true)} itemText="Edit" />
                                        </OverflowMenu>
                                    </div>
                                </div>
                            </Tile>
                        </div>
                        <div className="summary-body">
                            <Tile light={true} className="row w-full d-flex flex-w">
                                <div className="col-12 col-md-6 p-05">
                                    <div className="mb-05">
                                        <strong>ID:</strong> <span className="">{client.id}</span>
                                    </div>
                                    <div className="mb-05">
                                        <strong>Agreement Name:</strong> <span className="">{client.name}</span>
                                    </div>
                                    <div className="mb-05">
                                        <strong>End Date:</strong> <span className="">{client.enddate}</span>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-6 p-05">
                                    <div className="mb-05">
                                        <strong>Public Link<Tooltip direction="bottom"
                                            tabIndex={0}>
                                            <p>
                                                This is the link that prospective clients will use to sign the agreement.
                                            </p>
                                        </Tooltip> :</strong> <span className=""><Link href={`${SITE_URL}/sign-agreement/${client.id}/`}>{SITE_URL}/sign-agreement/{client.id}/</Link></span>
                                    </div>
                                </div>
                            </Tile>
                        </div>
                        <div className="w-full summary-footer">
                            <Tile light={true} className="w-full d-flex" style={{ minHeight: 0 }}>
                                <div className="col-6">
                                    <span className="text-sm"><strong>Start Date: </strong>{client.startdate}</span>
                                </div>
                                <div className="col-6 d-flex">

                                </div>
                            </Tile>
                        </div>
                    </div>

                    <Tile light={true} className="w-full d-flex mt-2" style={{ minHeight: 0 }}>
                        <div className="col-12 col-sm-12 col-md-12">
                            <div className='col-12 w-full d-flex mb-1'>
                                <div className='col-6'>
                                    <h4>Editor</h4>
                                </div>
                                <div className='col-6 d-flex ml-auto'>
                                    <p className='text-sm text-dark ml-auto mr-05 m-auto'>{savedState}</p>
                                    <Button onClick={() => editAgreement()}>Save</Button>
                                </div>
                            </div>
                            <SunEditor onChange={(e) => setEditorContent(e) & setSavedState("Unsaved Changes")} defaultValue={client.content} height="100%" setOptions={{
                                buttonList: [
                                    ['undo', 'redo'],
                                    ['font', 'fontSize', 'formatBlock'],
                                    ['paragraphStyle', 'blockquote'],
                                    ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                                    ['fontColor', 'hiliteColor', 'textStyle'],
                                    ['removeFormat'],
                                    '/', // Line break
                                    ['outdent', 'indent'],
                                    ['align', 'horizontalRule', 'list', 'lineHeight'],
                                    ['table', 'link', 'image' /** ,'math' */], // You must add the 'katex' library at options to use the 'math' plugin.
                                    /** ['imageGallery'] */ // You must add the "imageGalleryUrl".
                                    ['showBlocks', 'codeView'],
                                    ['preview', 'print'],
                                    /** ['dir', 'dir_ltr', 'dir_rtl'] */ // "dir": Toggle text direction, "dir_ltr": Right to Left, "dir_rtl": Left to Right
                                ]
                            }} />

                        </div>
                    </Tile>
                </>
            }
            <Modal
                open={openEditAgreementModal}
                modalHeading={"Edit Agreement #" + client?.id}
                modalLabel="Agreements"
                primaryButtonText="Save Changes"
                secondaryButtonText="Cancel"
                hasForm={true}
                onRequestClose={() => setOpenEditAgreementModal(false) & setError(false)}
                onRequestSubmit={() => editAgreementForm.current && editAgreementForm.current.click() & setError(false)}
            >   {error && <InlineNotification kind="error" hideCloseButton={true} title="Error: Unable to add note" subtitle="Please try again or contact your administrator." actions={<NotificationActionButton onClick={(() => setError(false))}>Dismiss</NotificationActionButton>} />}
                <p style={{ marginBottom: '1rem' }}>
                    Fill out the form to edit the agreement's information.
                </p>
                <Form id="addAgreement" onSubmit={(e) => editAgreementInformation(e)} className="d-flex flex-w">
                    <div className="col-12 m-005">
                        <TextInput
                            data-modal-primary-focus
                            id="name"
                            name="name"
                            defaultValue={client?.name}
                            labelText="Agreement Name"
                            placeholder="Enter agreement name"
                            style={{ marginBottom: '1rem' }}
                            required
                        />
                    </div>
                    <input type="submit" style={{ display: 'none' }} ref={editAgreementForm} />
                </Form>
            </Modal>
        </div>
    )
}

export default AgreementShell